/* Repair a missing offer attachment without replacing the paid cart contents. */
(() => {
  const products = new Set([8364739723450, 8412947742906, 8416946553018, 8502581362874]);
  const mystery = 46049979924666;
  const guide = 46049979891898;
  let busy = false;
  const root = () => window.Shopify?.routes?.root || '/';
  const request = async (path, body) => {
    const response = await fetch(root() + path, {
      method: body ? 'POST' : 'GET',
      headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    if (!response.ok) throw new Error('Offer refresh unavailable');
    return response.json();
  };
  const parentKey = item => item.parent_relationship?.parent_key || item.parent_relationship?.parent?.key;
  const refresh = async button => {
    if (busy) return;
    busy = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const status = button.parentElement.querySelector('[data-luscent-repair-status]');
    const say = text => { if (status) status.textContent = text; };
    say('Refreshing your offer...');
    let locked = false;
    try {
      const helper = window.Alpine?.store('xCartHelper');
      if (helper) await helper.waitForCartUpdate();
      else if (window.updatingCart) throw new Error('Cart update in progress');
      window.updatingCart = true;
      locked = true;
      const config = JSON.parse(document.getElementById('luscent-cart-offer-repair-config').textContent);
      let cart = await request('cart.js');
      const parents = cart.items.filter(item => !parentKey(item) && products.has(Number(item.product_id)));
      // Separate offer combinations have independent discount restrictions.
      // Leave their validation intact and avoid duplicating either reward pool.
      if (parents.length !== 1 || cart.currency !== config.currency) throw new Error('Offer requires review');
      let parent = parents[0];
      const mask = Number(parent.product_id) === 8364739723450;
      if (mask && !config.creditVariant) throw new Error('No matching credit currency');
      const marker = mask ? 'mask-store-credit-v1' : 'free-gifts-v1';
      const expected = mask
        ? [{ id: mystery, quantity: 1 }, { id: Number(config.creditVariant), quantity: 1 }]
        : [{ id: guide, quantity: parent.quantity }, { id: mystery, quantity: parent.quantity }];
      let children = cart.items.filter(item => parentKey(item) === parent.key);
      if (children.some(item => !expected.some(gift => gift.id === Number(item.variant_id || item.id)))) {
        throw new Error('Unexpected attached item');
      }
      for (const gift of expected) {
        const matches = children.filter(item => Number(item.variant_id || item.id) === gift.id);
        if (matches.length > 1 || (matches.length && matches[0].quantity !== gift.quantity)) {
          throw new Error('Attached quantity requires review');
        }
      }
      if (parent.properties?._luscent_offer !== marker) {
        const existingChildren = children.map(item => ({ id: Number(item.variant_id || item.id), quantity: item.quantity }));
        // A line key changes with its properties; always use the native response's new key.
        cart = await request('cart/change.js', {
          id: parent.key, quantity: parent.quantity,
          properties: { ...(parent.properties || {}), _luscent_offer: marker }
        });
        const updated = cart.items.filter(item => !parentKey(item) && products.has(Number(item.product_id)));
        if (updated.length !== 1 || updated[0].quantity !== parent.quantity || Number(updated[0].variant_id) !== Number(parent.variant_id)) {
          throw new Error('Cart changed during refresh');
        }
        parent = updated[0];
        children = cart.items.filter(item => parentKey(item) === parent.key);
        if (existingChildren.some(previous => !children.some(item => Number(item.variant_id || item.id) === previous.id && item.quantity === previous.quantity))) {
          throw new Error('Attached items changed during refresh');
        }
      }
      const missing = expected.filter(gift => !children.some(item => Number(item.variant_id || item.id) === gift.id));
      if (missing.length) {
        // Exactly one add attempt. On uncertainty the next explicit click rereads the cart.
        await request('cart/add.js', { items: missing.map(gift => ({
          ...gift, parent_line_key: parent.key, properties: { _luscent_offer: marker }
        })) });
      }
      // Refresh native Liquid validation. It alone decides whether checkout can proceed.
      if (helper) {
        const sections = helper.getSectionsToRender();
        const rendered = {};
        for (let offset = 0; offset < sections.length; offset += 5) {
          const ids = sections.slice(offset, offset + 5).map(section => section.id).join(',');
          const response = await fetch(window.location.pathname + '?sections=' + encodeURIComponent(ids));
          if (!response.ok) throw new Error('Unable to refresh cart display');
          Object.assign(rendered, await response.json());
        }
        await helper.reRenderSections(rendered);
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      } else {
        window.location.reload();
      }
    } catch (error) {
      say("We couldn't refresh this offer. Please try again or contact us for help.");
    } finally {
      if (locked) window.updatingCart = false;
      busy = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-luscent-refresh-offer]');
    if (!button) return;
    event.preventDefault();
    refresh(button);
  });
})();
